import { Box, Button, Card, Grid2, IconButton, List, ListItem, ListItemText, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../util/Loader";
import LoadingAwal from "../../util/LoadingAwal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}

const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Bsi = ({user_id, invoice_id}) => {
    const [loading, isLoading] = useState(true);
    const [error, isError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [rows, setRows] = useState({});
    const [value, setValue] = useState(0);
    const [code, setCode] = useState("");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const navigate = useNavigate();
     
    useEffect(() => {
        const init = () => {
            if(user_id && invoice_id) {
                axios.get(`https://ssr.radboox.com/data/xendit/bank_va/${user_id}?invoice_id=${invoice_id}&channel=BSI`)
                .then((res) => {
                    const data = res.data.message;
                    const codeBayar = (data.payment_code).split("9347");
                    setCode(codeBayar)
                    setRows(data)
                    isLoading(false)
                }).catch((e) =>{
                    isError(true)
                    setErrorMsg(e.response.data.message)
                    isLoading(false)
                })
            }
        }
        init();
    }, [user_id, invoice_id])

    const copyText = async() => {
        navigator.clipboard.writeText(rows?.payment_code);
        try {
            await navigator.clipboard.writeText(rows?.payment_code);
            /* Resolved - text copied to clipboard successfully */
        } catch (err) {
            // console.error('Failed to copy: ', err);
            /* Rejected - text failed to copy to the clipboard */
        }
    }

    return(
       <>
        {loading ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>
        ) : (
            <>
                {error ? (
                    <>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                            <Typography variant="body1">Mohon maaf, permintaan Anda tidak dapat di lanjutkan</Typography>
                            <Typography variant="body2">error code: {errorMsg}</Typography>
                            <Button sx={{marginY: 2, paddingX: 4, marginTop: 5}} variant="contained" onClick={() => navigate(-1)}>Kembali</Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Grid2 container justifyContent="center" margin={2}>
                            <Grid2 size={{xs: 12, sm: 8}}>
                                <img
                                    src={`https://content.radboox.com/public/upload/img/${rows?.cp_logo}`}
                                    alt="Company Profile"
                                    style={{
                                        align: "left",
                                        maxHeight: "70px",
                                        objectFit: "contain",
                                        backgroundColor: "#fff",
                                    }}
                                />
                                <Typography variant="h6" sx={{fontWeight: 800}}>{rows?.cp_name}</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 container justifyContent="center"> 
                            <Grid2 size={{xs: 12, sm: 8}}>
                                <Card variant="outlined" sx={{padding: 1}}>
                                    <Grid2 container padding={2} spacing={2}>
                                        <Grid2 size={{xs: 12, sm: 6}} order={{ xs: 2, sm: 1 }}>
                                            <Typography variant="body2">Nomor Virtual Account</Typography>
                                            <Typography variant="h5" sx={{marginBottom: 2}}>{rows?.payment_code}<IconButton onClick={() => copyText()} sx={{marginLeft: 2}} size="small"><ContentCopyIcon fontSize="inherit"/></IconButton></Typography>
                                            <Typography variant="body2">Nama Virtual Account</Typography>
                                            <Typography variant="h6" sx={{marginBottom: 2}}>{rows?.name}</Typography>
                                            <Typography variant="body2">Nominal Bayar</Typography>
                                            <Typography variant="h6">{rows?.expected_amount}</Typography>
                                        </Grid2>
                                        <Grid2 size={{xs: 12, sm: 6}} justifyItems="center" alignContent="center" order={{ xs: 1, sm: 2 }}>
                                            <img
                                                src={process.env.PUBLIC_URL + '/bank_logo/bsi.svg'}
                                                alt="Company Profile"
                                                style={{
                                                    align: "center",
                                                    minWidth: "200px",
                                                    // objectFit: "contain",
                                                    backgroundColor: "#fff",
                                                }}
                                            />
                                            <Typography variant="body2" sx={{marginTop: 0}}>Bayar Sebelum</Typography>
                                            <Typography variant="h6">{rows?.expiration_date}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Card>
                                <Box sx={{ width: '100%', marginY: 2 }}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                            <Tab label="MBANKING" {...a11yProps(0)} />
                                            <Tab label="IBANKING" {...a11yProps(1)} />
                                            <Tab label="ATM" {...a11yProps(2)} />
                                        </Tabs>
                                    </Box>
                                    <CustomTabPanel value={value} index={0}>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Masuk Ke Akun Anda
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Buka aplikasi BSI Mobile / Byond By BSI
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan Username dan Password anda
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Detail Pembayaran
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih Menu "Pembayaran" atau "Bayar & Beli"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih menu "Institusi" atau "Lembaga"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan nama institusi atau lembaga Xendit (kode 9347)
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan Nomor Virtual Account {code[1]} 
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Konfirmasi detail transaksi anda
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Transaksi Berhasil
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Setelah transaksi pembayaran Anda selesai, simpan bukti pembayaran
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Invoice Anda akan otomatis terbayar, jika dalam 5 menit Anda tidak menerima notifikasi melalui WhatsApp, silahkan menghubungi Admin kami.
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </CustomTabPanel>
                                    <CustomTabPanel value={value} index={1}>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Masuk ke Akun Anda
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Buka situs https://bsinet.bankbsi.co.id
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukan User ID dan Password
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Detail Pembayaran
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih Menu "Pembayaran" atau "Bayar & Beli"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih menu "Institusi" atau "Lembaga"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan nama institusi atau lembaga Xendit (kode 9347)
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan Nomor Virtual Account {code[1]} 
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Konfirmasi detail transaksi anda
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Transaksi Berhasil
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Setelah transaksi pembayaran Anda selesai, simpan bukti pembayaran
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Invoice Anda akan otomatis terbayar, jika dalam 5 menit Anda tidak menerima notifikasi melalui WhatsApp, silahkan menghubungi Admin kami.
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </CustomTabPanel>
                                    <CustomTabPanel value={value} index={2}>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                        Temukan ATM Terdekat
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukan kartu ATM BSI Anda
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukan Pin
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Detail Pembayaran
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih Menu "Pembayaran" atau "Bayar & Beli"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Pilih menu "Institusi" atau "Lembaga"
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Masukkan kode BSI VA Nomor Virtual Account {rows?.payment_code}
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Konfirmasi detail transaksi anda
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        <Typography sx={{ mt: 2}} variant="h6">
                                            Transaksi Berhasil
                                        </Typography>
                                        <List sx={{ listStyle: "decimal", pl: 4 }}>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Setelah transaksi pembayaran Anda selesai, simpan bukti pembayaran
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem sx={{ display: "list-item", padding: 0 }}>
                                                <ListItemText>
                                                Invoice Anda akan otomatis terbayar, jika dalam 5 menit Anda tidak menerima notifikasi melalui WhatsApp, silahkan menghubungi Admin kami.
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </CustomTabPanel>
                                    <Button sx={{marginY: 2, paddingX: 4}} variant="contained" onClick={() => navigate(-1)}>Kembali</Button>
                                </Box>
                            </Grid2>
                        </Grid2>
                    </>
                )}
            </>
        )}
       </>
    )
};

export default Bsi;